import React, { useState, useEffect, useCallback } from 'react';
import { DEFAULT_APP_LOCALE_CODE, TRANSITION, LOGIN, FAQ } from './constants';
import { YetToTransition } from './yetToTransition';
import { TransitionOrExistingUser } from './transitionOrExistingUser';
import { setFbPopupCookie, doesUrlHasSearchParam, track, TrackEvent, getUrlSearchParam, } from './helpers';
export const DeprecationWarningOverlay = ({ customer, localeCode = DEFAULT_APP_LOCALE_CODE, redirectPathOnClose = '', config, closable = true, callbackOnClose, setShowModal, isFbUserTransitioned, isFashionStoreUser, showModal, }) => {
    const [passwordResetEmail, setPasswordResetEmail] = useState('');
    useEffect(() => {
        track(TrackEvent.TRACK_DATA, {
            generatedUrl: 'facebook/deprecation/information',
        });
        if (doesUrlHasSearchParam(FAQ)) {
            track(TrackEvent.FAQ_CREATE_PASSWORD);
        }
    }, []);
    useEffect(() => {
        setPasswordResetEmail(customer.email);
    }, [JSON.stringify(customer)]);
    const handleOnClose = useCallback(() => {
        const path = getUrlSearchParam('redirectbackto');
        setShowModal(false);
        setFbPopupCookie();
        if (callbackOnClose) {
            callbackOnClose();
        }
        if (path) {
            window.history.pushState({}, '', path);
        }
    }, []);
    const isTransitionedLoungeUser = isFbUserTransitioned && !isFashionStoreUser;
    const props = {
        showModal,
        passwordResetEmail,
        localeCode,
        redirectPathOnClose,
        handleOnClose,
        closable,
    };
    if (isFashionStoreUser) {
        return React.createElement(TransitionOrExistingUser, { ...props, view: LOGIN });
    }
    if (isTransitionedLoungeUser) {
        return React.createElement(TransitionOrExistingUser, { ...props, view: TRANSITION });
    }
    return (React.createElement(YetToTransition, { ...props, customer: customer, setPasswordResetEmail: setPasswordResetEmail, config: config }));
};
//# sourceMappingURL=DeprecationWarningOverlay.js.map